import SecureLS from "secure-ls";

const ls = new SecureLS();

export function authHeader() {
  // return authorization header with jwt token
  let token = ls.get("token");
  if (token) {
    return { Authorization: "Bearer " + token };
  } else {
    console.warn("No token found in secure storage");
    return {};
  }
}
